import { ReactComponent as CancelSquareIcon } from 'assets/cancel-square-black.svg';
import { ReactComponent as ViewIcon } from 'assets/view.svg';
import { MenuOptionType, OptionComponentEnum } from './types';

export const MENU_OPTIONS: MenuOptionType[] = [
  {
    id: 'view_details',
    label: 'View Details',
    type: OptionComponentEnum.link,
    Icon: ViewIcon,
  },
  {
    id: 'follow',
    label: 'Follow',
    type: OptionComponentEnum.button,
    Icon: CancelSquareIcon,
  },
  {
    id: 'remove_account',
    label: 'Remove Account',
    type: OptionComponentEnum.button,
    Icon: CancelSquareIcon,
  },
];
